// extracted by mini-css-extract-plugin
export var Blog = "blog-module--Blog--bf5fe";
export var Cross = "blog-module--Cross--7b07b";
export var ExtraContent = "blog-module--ExtraContent--cc81b";
export var Header = "blog-module--Header--d5e9a";
export var Loading = "blog-module--Loading--197e6";
export var Pagination = "blog-module--Pagination--e925d";
export var PaginationContainer = "blog-module--PaginationContainer--57f21";
export var PaginationPrevious = "blog-module--PaginationPrevious--b129f";
export var Result = "blog-module--Result--4f2fb";
export var Results = "blog-module--Results--5a3a8";
export var Search = "blog-module--Search--fc71f";
export var Searching = "blog-module--Searching--9344d";
export var Select = "blog-module--Select--3932c";
export var ToggleMoreButton = "blog-module--ToggleMoreButton--a7c63";
export var active = "blog-module--active--22489";
export var clock = "blog-module--clock--05e00";
export var floating = "blog-module--floating--2748d";